<div class="main-page">
  <div *ngIf="updateForm">
    <app-create-event
      status="update"
      [dataObj]="updatedData"
    ></app-create-event>
  </div>

  <div class="container" *ngIf="!updateForm">
    <ngx-ui-loader [loaderId]="'loader-01'"></ngx-ui-loader>
    <div class="mm-events-wrap">
      <div class="mm-events-container">
        <div class="mm-events-header">
          <div class="mm-events-titleblock">
            <h4 class="mm-events-title">
              <i class="fas fa-calendar-alt mm-events-title-icon" aria-hidden="true"></i>
              Events
            </h4>
            <div class="mm-events-subtitle">
              Manage your events and track engagement.
              <span class="mm-events-count">({{ activeEvents?.length || 0 }} items)</span>
            </div>
          </div>

          <button (click)="createEvent()" class="mm-btn-create">
            <i class="fas fa-plus" aria-hidden="true"></i> Create
          </button>
        </div>

        <div class="mm-events-tabs">
          <button
            type="button"
            class="mm-tab"
            [class.active]="activeTab === 'all'"
            (click)="setTab('all')"
          >
            <i class="fas fa-layer-group" aria-hidden="true"></i> All
            <span class="mm-pill">{{ events?.length || 0 }}</span>
          </button>

          <button
            type="button"
            class="mm-tab"
            [class.active]="activeTab === 'upcoming'"
            (click)="setTab('upcoming')"
          >
            <i class="fas fa-clock" aria-hidden="true"></i> Upcoming
            <span class="mm-pill">{{ upcomingEvents?.length || 0 }}</span>
          </button>

          <button
            type="button"
            class="mm-tab"
            [class.active]="activeTab === 'expired'"
            (click)="setTab('expired')"
          >
            <i class="fas fa-hourglass-end" aria-hidden="true"></i> Expired
            <span class="mm-pill">{{ expiredEvents?.length || 0 }}</span>
          </button>
        </div>

        <div *ngIf="activeEvents?.length === 0" class="mm-empty">
          <img class="mm-empty-img" src="../../assets/no-data.png" alt="No records" />
          <h5 class="mm-empty-title">No Record Found</h5>
          <p class="mm-empty-subtitle">Create your first event to get started.</p>
        </div>

        <div class="mm-events-grid" *ngIf="activeEvents?.length > 0">
          <div class="mm-event-card" *ngFor="let event of pagedEvents; let i = index" [style.animation-delay]="(i * 0.05) + 's'">
            <div class="mm-event-img">
              <img
                [src]="event?.photo | merchantCoverPhoto"
                alt="Event photo"
                (error)="onImgError($event, 'assets/placeholderCoverPhoto.jpeg')"
              />
              <div class="mm-event-badges">
                <span class="mm-badge" [class.mm-badge--upcoming]="activeTab !== 'expired'" [class.mm-badge--expired]="activeTab === 'expired'">
                  {{ activeTab === 'expired' ? 'Expired' : (activeTab === 'upcoming' ? 'Upcoming' : 'Event') }}
                </span>
              </div>
            </div>

            <div class="mm-event-body">
              <div class="mm-event-name" (click)="openModal(content, event)">
                {{ event?.eventName }}
              </div>

              <div class="mm-event-row">
                <div class="mm-event-label">
                  <i class="fas fa-calendar-day" aria-hidden="true"></i> Dates
                </div>
                <div class="mm-event-value">
                  {{ event?.validFrom | date:'MMM dd, yyyy' }} – {{ event?.validTill | date:'MMM dd, yyyy' }}
                </div>
              </div>

              <div class="mm-event-row">
                <div class="mm-event-label">
                  <i class="fas fa-map-marker-alt" aria-hidden="true"></i> Location
                </div>
                <div class="mm-event-value mm-clamp-1">
                  {{ event?.address?.streetAddress || '-' }}
                </div>
              </div>

              <div class="mm-event-stats">
                <div class="mm-stat">
                  <i class="fas fa-user-friends" aria-hidden="true"></i>
                  <span class="mm-stat-label">Followers</span>
                  <span class="mm-stat-val">{{ event?.followersCount || 0 }}</span>
                </div>
                <div class="mm-stat">
                  <i class="fas fa-users" aria-hidden="true"></i>
                  <span class="mm-stat-label">Attendees</span>
                  <span class="mm-stat-val">{{ event?.attendeeCount || 0 }}</span>
                </div>
              </div>

              <div class="mm-event-actions">
                <button type="button" class="mm-btn mm-btn--ghost" (click)="openModal(content, event)">
                  <i class="far fa-eye" aria-hidden="true"></i> View
                </button>
                <button type="button" class="mm-btn mm-btn--primary" (click)="openUpdate(event?._id)">
                  <i class="far fa-edit" aria-hidden="true"></i> Edit
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="mm-pagination" *ngIf="activeEvents?.length > 0 && totalPages > 1">
          <button class="mm-page-btn" (click)="prevPage()" [disabled]="page <= 1">
            <i class="fas fa-chevron-left" aria-hidden="true"></i> Previous
          </button>
          <span class="mm-page-info">Page {{ page }} of {{ totalPages }}</span>
          <button class="mm-page-btn" (click)="nextPage()" [disabled]="page >= totalPages">
            Next <i class="fas fa-chevron-right" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <ng-template #content let-modal>
    <div class="modal-header">
      <div class="card-body card-withoutshadow">
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"
        >
          X
        </button>
        <div class="image-wrapper">
          <img
            class="card-img-top"
            [src]="eventDetails.photo"
            (error)="changeSource($event)"
            alt=""
          />
        </div>
        <h5
          class="card-title margin-b cursor text-left mt-5"
          (click)="modal.dismiss('Cross click')"
        >
          {{ eventDetails.eventName }}
        </h5>
        <div class="detail-text">
          <div><i class="fa fa-calendar" aria-hidden="true"></i></div>
          <div class="text-wrap margin-l">
            {{ eventDetails.validFrom | date }} to
            {{ eventDetails.validTill | date }}
          </div>
        </div>
        <div class="detail-text">
          <div><i class="fa fa-clock-o" aria-hidden="true"></i></div>
        <div class="text-wrap margin-l">
          {{ eventDetails.startTime | date : "h:mm a" }} to
          {{ eventDetails.endTime | date : "h:mm a" }}
        </div>
      </div>

        <div class="detail-text">
          <div><i class="fa fa-map-marker" aria-hidden="true"></i></div>
          <div class="text-left margin-l">
            {{ eventDetails?.address.streetAddress }}
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
